import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_expense,
  add_expense,
  update_expense,
  delete_expense,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    expense: [],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    amount: "",
    type: "",
    phone_no: "",
    email: "",
    bank_account:"",

    remark: "",
    status:""
  },
};


// Async Thunks for API Calls
export const fetchexpense = createAsyncThunk(
  "expense/fetchexpense",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_expense(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createexpense = createAsyncThunk(
  "expense/createexpense",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_expense(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexpense = createAsyncThunk(
  "expense/updateexpense",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_expense(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexpense = createAsyncThunk(
  "expense/deleteexpense",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_expense({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const expenseSlice = createSlice({
  name: 'expenses',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
 EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        amount: "",
        type: "",
        phone_no: "",
        email: "",
        bank_account: "",
        remark: "",
        status:""
      };
    },
    setexpense(state, action) {
      state.expense = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
  

       // Fetch hostel_category
       .addCase(fetchexpense.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexpense.fulfilled, (state, action) => {
        state.loading = false;
        state.expense = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createexpense.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexpense.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexpense.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateexpense.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexpense.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexpense.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteexpense.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexpense.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexpense.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexpense,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = expenseSlice.actions;
export default expenseSlice.reducer;
